import React, {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { TextInput } from '../../../../ui/input/text_input/text_input';
import { ToggleInput } from '../../../../ui/input/toggle_input/toggle_input';

type SessionTitleProps = {
  sessionTitle: string;
  defaultValue: string;
  setSessionTitle: Dispatch<SetStateAction<string>>;
  disabled?: boolean;
};

export const SessionTitle = ({
  sessionTitle,
  defaultValue,
  setSessionTitle,
  disabled,
}: SessionTitleProps) => {
  const [active, setActive] = useState<boolean>(true);

  useEffect(() => {
    if (active) {
      setSessionTitle(defaultValue);
    }
  }, [active, defaultValue]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!active) {
      setSessionTitle(event.target.value);
    }
  };

  const setActiveStatus = () => {
    if (disabled) return;
    setActive(!active);
    if (!active) {
      setSessionTitle(defaultValue);
    }
  };

  return (
    <section className='rounded-lg border border-slate-200 bg-white p-3 shadow-sm'>
      <div className='flex flex-col gap-3 lg:flex-row lg:items-end'>
        <div className='min-w-0 flex-1'>
          <div className='mb-2 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between'>
            <div>
              <p className='text-sm font-extrabold text-slate-900'>
                Generation Title
              </p>
              <p className='text-xs text-slate-500'>
                Use auto title for consistent generated-question sessions.
              </p>
            </div>
            <div
                className={`inline-flex w-fit items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-bold transition ${
                  active
                    ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
                    : 'border-slate-200 bg-slate-50 text-slate-600'
                } disabled:cursor-not-allowed disabled:opacity-60`}
            >
              <span>{ active ? 'Auto title' : 'Manual title' }</span>
              <ToggleInput
                  toggled={active}
                  handleToggle={setActiveStatus}
                  name='default'
                  disabled={!!disabled}
              />
            </div>
          </div>

          <TextInput
              name='topic'
              value={sessionTitle || ''}
              type='text'
              onChange={handleInputChange}
              placeholder='Add session title...'
              disabled={active || !!disabled}
          />
          <p className='mt-1 text-xs text-slate-500'>
            { active
              ? 'Auto generated from the topic and timestamp.'
              : 'Manual title enabled.' }
          </p>
        </div>
      </div>
    </section>
  );
};
